// The one ApiClient every screen shares (ADR-032). Each shell's root creates a single client bound
// to the live CSRF token and wires its `onSessionExpired` to its central sign-out/redirect
// (FLOW-002), then provides it here around the whole tree — so every screen that reads the client
// through `useApi()` gets the same instance and the same 401 handling, instead of each screen
// building its own (the per-screen `ApiContext`/`ApiClientContext` contexts and screen-local
// clients this replaces, TASK-140).
import { createContext } from "preact";
import { useContext } from "preact/hooks";
import type { ApiClient } from "./client";

export const ApiContext = createContext<ApiClient | null>(null);

/** Pulled out of `useApi` so the "missing provider" branch is a plain function, testable without a component render. */
export function requireApiClient(client: ApiClient | null): ApiClient {
  if (!client) throw new Error("ApiContext.Provider is missing above this screen");
  return client;
}

/** The shared client; throws if a screen somehow renders with no `<ApiContext.Provider>` above it. */
export function useApi(): ApiClient {
  return requireApiClient(useContext(ApiContext));
}

// The org a screen shows and its money policy sit beside the client every screen already reads (TASK-240).
export { OrgHostContext, proxyAdminAreaHost, useOrgContext, type OrgContext, type OrgHost } from "./org-context";
